<div class="wrapper">
	<div class="logo_wrapper">
		<img src="../../../assets/tresen/smoothr_logo.svg" alt />
	</div>

	<div class="smoothr-block">
		<div class="form-block">
			<h2 class="title">Printer Ip</h2>
			<div class="form-item">
				<h3>Enter Ip</h3>
				<div class="input-group">
					<input [formControl]="printerForm" type="string" />
				</div>
				<div class="input-group">
					<input [formControl]="printerPort" type="string" />
				</div>
				<div class="input-group-checkbox">
					<input [formControl]="printerCrypto" type="checkbox" />
					<h3>Crypto</h3>
				</div>
				<div class="input-group-checkbox">
					<input [formControl]="printerAutomatic" type="checkbox" />
					<h3>Automatic Print</h3>
				</div>
			</div>
		</div>
	</div>

	<div class="footer-btn">
		<button (click)="close()">
			<h3>{{ 'common.close' | translate }}</h3>
		</button>
		<button class="save" (click)="save()">
			<h3>{{ 'common.save' | translate }}</h3>
		</button>
	</div>
</div>
